import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, ParamMap } from "@angular/router";
import { DomSanitizer } from '@angular/platform-browser';
import { LayoutPrintFormService } from "./layout-print-form.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-layout-print-form',
  templateUrl: './layout-print-form.component.html',
  styleUrls: ['./layout-print-form.component.css'],
  providers: [
    LayoutPrintFormService
  ]
})
export class LayoutPrintFormComponent implements OnInit {
  isLoading: boolean;
  idLayout: string;
  title: string;
  printData: Array<any>;
  style: any;
  selectedQrCode: any = {};
  css: string = '';
  configCss: any;
  sizeQrcode: any;
  layoutPrint: any;
  nameLayout: string = '';
  size: any;
  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private layoutPrintFormService: LayoutPrintFormService,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.size = 'big';
    this.toastr.setRootViewContainerRef(vcr);
    this.configCss = {
      '.layout-print': {
        'width': { value: [10.3], unit: 'cm' }
      },
      '.item-sm': {
        'width': { value: [5], unit: 'cm' },
        'height': { value: [4], unit: 'cm' },
        'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
      },
      '.item-lg': {
        'width': { value: [5], unit: 'cm' },
        'height': { value: [5], unit: 'cm' },
        'padding': { value: [0.5, 0, 0.5, 0], unit: 'cm' }
      },
      '.info-sm': {
        'font-size': { value: [10], unit: 'pt' },
        'line-height': { value: [0.85], unit: '' },
      },
      '.info-lg': {
        'font-size': { value: [12], unit: 'pt' },
        'line-height': { value: [1], unit: '' },
      },
      '.sub-info-lg': {
        'font-size': { value: [12], unit: 'pt' },
        'height': { value: [0.5], unit: 'cm' },
        'line-height': { value: [0.9], unit: '' }
      },
      'qrcode-sm': { value: [1.6], unit: 'cm' },
      'qrcode-lg': { value: [1.9], unit: 'cm' }
    }
  }


  ngOnInit() {
    this.title = 'Edit Layout Print';
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idLayout = params.get('id');
      if (this.idLayout === 'create') {
        this.title = 'Create Layout Print';
      } else {
        this.getLayoutPrintById();
      }
    });
    this.sizeQrcode = [];
    for (let i = 10; i <= 30; i++) {
      this.sizeQrcode.push(i / 10);
    }
    this.initData();
    this.renderCss();
  }

  initData(className: string = '') {
    this.printData = [];
    for (let i = 0; i < 4; i++) {
      this.printData.push(JSON.parse(`{"formatCode":"GWN2KNBV5SUT-SJLI46SL7-FFD97AA955C84C0DAB4695BBA25ADE200F7A3463","productId":"GW-GUN-V1","serialId":"GWN2KNBV5SUT","noId":"SJLI46SL7","hmac":"FFD97AA955C84C0DAB4695BBA25ADE200F7A3463","numberPerCode":10,"description":"Goodwill safes","createdAt":1521479037000,"used":true}`));
    }

    if (className != '') {
      this.selectedQrCode = {
        name: className == 'item-sm' ? 'Small QRCode' : 'Big QRCode',
        class: '.' + className,
        classInfo: className == 'item-sm' ? '.info-sm' : '.info-lg'
      };
    }
  }

  renderCss(attr: string = '', value: number = 0) {
    switch (attr) {
      case 'width': {
        this.configCss['.item-sm']['width'].value[0] = this.configCss['.item-lg']['width'].value[0] = value;
      } break;
      // case 'height' + this.selectedQrCode.class: {
      //   let increaValue;
      //   increaValue = value - (this.configCss[this.selectedQrCode.class]['padding'].value[0] + this.configCss[this.selectedQrCode.class]['padding'].value[2] + this.configCss['qrcode-sm'].value[0]);
      //   if (this.selectedQrCode.class == '.item-lg')
      //     increaValue = value - (this.configCss[this.selectedQrCode.class]['padding'].value[0] + this.configCss[this.selectedQrCode.class]['padding'].value[2] + this.configCss['.sub-info-lg']['height'].value[0] + this.configCss['qrcode-lg'].value[0]);
      //   this.configCss[this.selectedQrCode.class]['padding'].value[0] += increaValue / 2;
      //   this.configCss[this.selectedQrCode.class]['padding'].value[2] += increaValue / 2;
      // } break;
      // case 'line-height' + this.selectedQrCode.classInfo: {
      //   this.configCss['.item-sm']['height'].value[0] = this.configCss['.item-sm']['padding'].value[0] + this.configCss['.item-sm']['padding'].value[2] + this.configCss['qrcode-sm'].value[0];
      //   this.configCss['.item-lg']['height'].value[0] = this.configCss['.item-lg']['padding'].value[0] + this.configCss['.item-lg']['padding'].value[2] + this.configCss['.sub-info-lg']['height'].value[0] + this.configCss['qrcode-lg'].value[0];
      // }
      // default: {
      //   this.configCss['.item-sm']['height'].value[0] = this.configCss['.item-sm']['padding'].value[0] + this.configCss['.item-sm']['padding'].value[2] + this.configCss['qrcode-sm'].value[0];
      //   this.configCss['.item-lg']['height'].value[0] = this.configCss['.item-lg']['padding'].value[0] + this.configCss['.item-lg']['padding'].value[2] + this.configCss['.sub-info-lg']['height'].value[0] + this.configCss['qrcode-lg'].value[0];
      // }
      //   break;
    }
    this.configCss['.layout-print']['width'].value[0] = 2 * this.configCss['.item-sm']['width'].value[0] + 0.3;
    this.css = '';
    for (let key1 in this.configCss) {
      if (key1 === 'qrcode-sm' || key1 === 'qrcode-lg') {
        continue;
      }
      let temp: string = '';
      for (let key2 in this.configCss[key1]) {
        if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 1) {
          temp += `
          ${key2}: ${this.configCss[key1][key2].value}${this.configCss[key1][key2].unit};`
        }
        if (this.configCss[key1][key2].value && this.configCss[key1][key2].value.length == 4) {
          temp += `${key2}: ${this.configCss[key1][key2].value[0]}${this.configCss[key1][key2].unit} ${this.configCss[key1][key2].value[1]}${this.configCss[key1][key2].unit} ${this.configCss[key1][key2].value[2]}${this.configCss[key1][key2].unit} ${this.configCss[key1][key2].value[3]}${this.configCss[key1][key2].unit};`;
        }
      }
      this.css += `
      ${key1} {${temp}
      }`;

    }
    this.style = this.sanitizer.bypassSecurityTrustHtml('<style>' + this.css + '</style>');
  }

  getLayoutPrintById() {
    this.isLoading = true;
    this.layoutPrintFormService.getLayoutPrint(this.idLayout)
      .then(res => {
        if (res.status === 1) {
          this.layoutPrint = res.data;
          this.configCss = JSON.parse(this.layoutPrint.jsonCss);
          this.nameLayout = this.layoutPrint.name;
          this.renderCss();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      }).catch(err => console.log(err))
  }

  saveLayoutPrint() {
    this.isLoading = true;
    switch (this.idLayout) {
      case 'create': {
        let data = {
          name: this.nameLayout,
          jsonCss: JSON.stringify(this.configCss)
        }
        console.log(data);
        this.layoutPrintFormService.createLayoutPrint(data)
          .then(
            res => {
              if( res.status === 1 )
              {
                this.toastr.success(res.message , 'Success!');
              } else {
                this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                  localStorage.setItem("alert", JSON.stringify(res.message));
                  this.router.navigate(['login']);
                }
              }
              this.isLoading = false;
            }
          ).catch(err=> console.log(err))
      } break;
      default: {
        let data = {
          id: this.layoutPrint.id,
          name: this.nameLayout,
          jsonCss: JSON.stringify(this.configCss)
        }
        this.layoutPrintFormService.editLayoutPrint(data)
        .then(res=>{
          if( res.status === 1 )
          {
            this.toastr.success(res.message , 'Success!');
          } else {
            this.toastr.error(res.message, 'Error!');
            if (res.errorCode === 3000) {
              localStorage.setItem("alert", JSON.stringify(res.message));
              this.router.navigate(['login']);
            }
          }
          this.isLoading = false;
        }).catch(err => console.log(err))
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print-form/layout-print-form.component.ts